import * as GC from '@grapecity/spread-sheets';
import { ExportAlmMethod } from '@models/export-alm/export-alm-method';
import { setGreenArea } from '@shared/spread/spread-action-keys';
import { SpreadContextMenu } from '@shared/spread/spread-context-menu';
import { defaultBookOptions } from '@shared/spread/spread-settings';

enum tabColours {
  blue = '#5e91dd',
  green = '#72bf44',
  yellow = '#ffcd40'
}

interface IALMsheet {
  name: string;
  color: string;
  method: ExportAlmMethod;
}

export const baseSheets: ReadonlyArray<IALMsheet> = [
  { name: 'Lookup Tables', color: tabColours.green, method: ExportAlmMethod.NonMaturity },
  { name: 'EMP_CurrentPosition', color: tabColours.blue, method: ExportAlmMethod.NonMaturity },
  { name: 'Lookup Tables', color: tabColours.green, method: ExportAlmMethod.Vintage },
  { name: 'Vintage CP Table', color: tabColours.blue, method: ExportAlmMethod.Vintage },
  { name: 'Forecasts', color: tabColours.green, method: ExportAlmMethod.Vintage }
];

export const workbookInit = args => {
  const spread: GC.Spread.Sheets.Workbook = args.spread;
  return spread;
};

export const setUpWorkbook = (spread: GC.Spread.Sheets.Workbook) => {
  spread.options = { ...spread.options, ...defaultBookOptions };
  spread.options.tabStripVisible = true;
  SpreadContextMenu.setCopyCutPaste(spread);
  spread.options.defaultDragFillType = GC.Spread.Sheets.Fill.AutoFillType.fillWithoutFormatting;
  spread.options.allowExtendPasteRange = true;

  for (let i = 0; i < spread.sheets.length; i++) {
    spread.removeSheet(i);
  }
};

export const configureSheet = (sheet: GC.Spread.Sheets.Worksheet, baseSheet: IALMsheet) => {
  sheet.suspendPaint();
  sheet.suspendEvent();

  GC.Spread.Sheets.Commands.autoFitColumn.canUndo = false;

  // Sheet Options
  sheet.name(baseSheet.name);
  sheet.options.sheetTabColor = baseSheet.color;

  sheet.defaults.colWidth = 120;
  sheet.defaults.rowHeight = 24;
  sheet.options.allowCellOverflow = true;
  sheet.options.clipBoardOptions = GC.Spread.Sheets.ClipboardPasteOptions.values;
  sheet.options.colHeaderVisible = false;
  sheet.options.frozenlineColor = 'transparent';

  // Sheet Protection Options
  sheet.options.isProtected = true;
  sheet.options.protectionOptions = {
    ...sheet.options.protectionOptions,
    allowSelectLockedCells: true,
    allowSelectUnlockedCells: true,
    allowSort: false,
    allowFilter: false,
    allowEditObjects: false,
    allowResizeRows: false,
    allowDragInsertRows: false,
    allowDragInsertColumns: false,
    allowInsertRows: false,
    allowInsertColumns: false,
    allowDeleteRows: false,
    allowDeleteColumns: false
  };

  setGreenArea({ page: baseSheet.name, startRow: 0, startCol: 0, paddingRows: 0, paddingCols: 0 });

  sheet.resumePaint();
  sheet.resumeEvent();
};
